import React from 'react';
import { BoardResizeHandle } from '../boardResizeHandle.js';
import { BoardShapeSvgElement } from '../boardShapeSvgElement.js';

export const BoardMapShapesLayer = ({
  backShapes = [],
  frontShapes = [],
  shapes = [],
  editable = false,
  selectedShapeId = null,
  selectedShapeIds = [],
  onSelectShape,
  onShapeDoubleClick,
  onShapePointerDown,
  onShapeResizePointerDown,
  canvasWidth,
  canvasHeight,
  shapeDraft = null,
  offsetX = 0,
  offsetY = 0,
  getShapeNodeId,
}) => (
  <>
    <svg
      className='absolute inset-0'
      width={canvasWidth}
      height={canvasHeight}
      viewBox={`0 0 ${canvasWidth} ${canvasHeight}`}
      preserveAspectRatio='none'
      style={{ zIndex: 9, pointerEvents: 'none' }}
    >
      {backShapes.map(shape => {
        const isSelected =
          selectedShapeId === shape?.id || selectedShapeIds.includes(shape?.id);
        return (
          <BoardShapeSvgElement
            key={shape?.id}
            shape={shape}
            offsetX={offsetX}
            offsetY={offsetY}
            isSelected={isSelected}
            interactive={true}
            dataMapShapeRoot={true}
            dataMapNodeId={getShapeNodeId?.(shape?.id || '')}
            onPointerDown={event => {
              event.stopPropagation();
              onShapePointerDown?.(event, shape?.id || null);
            }}
            onClick={event => {
              event.stopPropagation();
              onSelectShape?.(shape?.id || null);
            }}
            onDoubleClick={event => {
              event.stopPropagation();
              onShapeDoubleClick?.(shape?.id || null);
            }}
          />
        );
      })}
    </svg>
    <svg
      className='absolute inset-0'
      width={canvasWidth}
      height={canvasHeight}
      viewBox={`0 0 ${canvasWidth} ${canvasHeight}`}
      preserveAspectRatio='none'
      style={{ zIndex: 30, pointerEvents: 'none' }}
    >
      {frontShapes.map(shape => {
        const isSelected =
          selectedShapeId === shape?.id || selectedShapeIds.includes(shape?.id);
        return (
          <BoardShapeSvgElement
            key={`${shape?.id}-front`}
            shape={shape}
            offsetX={offsetX}
            offsetY={offsetY}
            isSelected={isSelected}
            interactive={true}
            dataMapShapeRoot={true}
            dataMapNodeId={getShapeNodeId?.(shape?.id || '')}
            onPointerDown={event => {
              event.stopPropagation();
              onShapePointerDown?.(event, shape?.id || null);
            }}
            onClick={event => {
              event.stopPropagation();
              onSelectShape?.(shape?.id || null);
            }}
            onDoubleClick={event => {
              event.stopPropagation();
              onShapeDoubleClick?.(shape?.id || null);
            }}
          />
        );
      })}
      {shapeDraft ? (
        <BoardShapeSvgElement
          shape={shapeDraft}
          offsetX={offsetX}
          offsetY={offsetY}
          preview={true}
        />
      ) : null}
    </svg>
    {selectedShapeId &&
      shapes
        .filter(shape => shape?.id === selectedShapeId)
        .map(shape => (
          <div
            key={`${shape.id}-resize-handle`}
            className='absolute pointer-events-none'
            style={{
              left: (Number(shape?.x) || 0) + offsetX,
              top: (Number(shape?.y) || 0) + offsetY,
              width: Math.max(8, Number(shape?.w) || 0),
              height: Math.max(8, Number(shape?.h) || 0),
              zIndex: 12,
            }}
          >
            <BoardResizeHandle
              dataAttrName='data-map-shape-resize-handle'
              visible={editable}
              onPointerDown={event => {
                event.stopPropagation();
                onShapeResizePointerDown?.(event, shape.id);
              }}
            />
          </div>
        ))}
  </>
);
